import * as React from 'react';

export default {
  OmicsExplorer: React.lazy(
    () =>
      import(
        /* webpackChunkName: "omics-explorer" */
        './'
      ),
  ),
};
